import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import { CloudUpload as CloudUploadIcon } from '@material-ui/icons';
import { i18n } from '../../translate/i18n';

const useStyles = makeStyles((theme) => ({
  overlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: theme.zIndex.modal - 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    backgroundColor:
      theme.palette.type === 'dark' ? 'rgba(11, 20, 26, 0.82)' : 'rgba(248, 250, 252, 0.88)',
    // O overlay não pode ser alvo de drag: se fosse, dragenter/dragleave
    // disparariam nele e o contador de profundidade do container nunca zeraria.
    pointerEvents: 'none',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    textAlign: 'center',
    width: '100%',
    height: '100%',
    maxWidth: 520,
    maxHeight: 320,
    borderRadius: 16,
    border: `2px dashed ${theme.palette.primary.main}`,
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    padding: theme.spacing(3),
  },
  icon: {
    fontSize: 48,
    color: theme.palette.primary.main,
  },
  title: {
    fontSize: '1.125rem',
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  subtitle: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
  },
}));

/**
 * Feedback visual de "solte o arquivo aqui". Renderizado dentro de um container
 * com `position: relative` (ver `useFileDropZone`).
 */
const FileDropOverlay = ({ visible, title, subtitle }) => {
  const classes = useStyles();

  if (!visible) return null;

  return (
    <Box className={classes.overlay} aria-hidden>
      <Box className={classes.card}>
        <CloudUploadIcon className={classes.icon} />
        <Typography className={classes.title} component="div">
          {title || i18n.t('messageInput.dropzone.title')}
        </Typography>
        <Typography className={classes.subtitle} component="div">
          {subtitle || i18n.t('messageInput.dropzone.subtitle')}
        </Typography>
      </Box>
    </Box>
  );
};

export default FileDropOverlay;
